import {
    optionTitle_availability,
    optionSearch_availability,
} from './AvailabilityOption.locstring.json';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import { isFeatureEnabled } from 'owa-feature-flags';
import { getOWAConnectedAccounts } from 'owa-accounts-store';

var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
let AvailabilityOption: LazyOption = createLazyOption(
    {
        key: 'mergedViewAvailability',
        titleStringKey: optionTitle_availability,
        searchTermsStringKey: optionSearch_availability,
        isHidden: () => {
            return (
                !isFeatureEnabled('cal-truTime') ||
                isConsumer() ||
                getOWAConnectedAccounts().length == 0
            );
        },
    },
    lazyFullModule,
    m => m.default
);
export default AvailabilityOption;
